module.exports = __webpack_public_path__ + "static/img/wealth_level_65.b73c0f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_65.png
// module id = rMmr
// module chunks = 0